import { takeEvery, fork, put, all, call } from 'redux-saga/effects'

import fetch from './../../../fetch'
import {
  baseURL,
  commonHeaders,
} from './../../../../../Containers/Confiq/index'

import {
  GET_LOCATION,
  GET_LOCATION_SUCCESS,
  GET_LOCATION_ERROR,
} from './../../../actionType'

function* getLocation({ payload }) {
  try {
    const response = yield call(fetch, {
      url: `${baseURL}/parse/classes/golfbookings/${payload.id}`,
      method: 'GET',
      headers: { ...commonHeaders },
    })

    console.log('mytestingResponse', response, response?.error)
    if (response?.error === undefined) {
      yield put({ type: GET_LOCATION_SUCCESS, payload: response })
    } else {
      yield put({ type: GET_LOCATION_ERROR, payload: response.error })
    }
  } catch (error) {
    yield put({ type: GET_LOCATION_ERROR, payload: error })
  }
}

export function* watchGetLocation() {
  yield takeEvery(GET_LOCATION, getLocation)
}

function* getLocationSaga() {
  yield all([fork(watchGetLocation)])
}

export default getLocationSaga
